import { render, staticRenderFns } from "./InvalidOrganizationView.vue?vue&type=template&id=6314dbfb"
import script from "./InvalidOrganizationView.vue?vue&type=script&lang=ts"
export * from "./InvalidOrganizationView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports